<script lang="ts">
    import CustomerNameFormSelect from "@apps/reviews/components/CustomerNameFormSelect.svelte";
    import ReviewsTextInput from "@apps/reviews/components/ReviewsTextInput/ReviewsTextInput.svelte";
    import { REVIEWER_NAME_DISPLAY_FORMAT } from "@apps/reviews/constants";
    import ReviewsStorefrontValuesSettingsEntity from "@apps/reviews/entities/ReviewsStorefrontValuesSettingsEntity";
    import FormManager from "@lib/FormManager/FormManager";
    import FormManagerController from "@lib/FormManager/FormManagerController.svelte";
    import FormManagerProvider from "@lib/FormManager/FormManagerProvider.svelte";
    import { I18nModule } from "@modules/i18n/I18nModule";
    import { container } from "tsyringe";

    import FormLayout from "@components/FormLayout/FormLayout.svelte";
    import FormLayoutItem from "@components/FormLayout/FormLayoutItem.svelte";

    export let isAuthenticated: boolean;
    export let guestInfoFormManager: FormManager;
    export let reviewsSettings: ReviewsStorefrontValuesSettingsEntity;

    const i18nModule = container.resolve(I18nModule);
    const t_guest_name_input_label$ = i18nModule.exports.i18n.selectT(
        "reviews.ReviewsFormModalWidget",
        "guest_name_input_label"
    );
    const t_guest_name_input_placeholder$ = i18nModule.exports.i18n.selectT(
        "reviews.ReviewsFormModalWidget",
        "guest_name_input_placeholder"
    );
    const t_guest_email_input_label$ = i18nModule.exports.i18n.selectT(
        "reviews.ReviewsFormModalWidget",
        "guest_email_input_label"
    );
    const t_guest_email_input_placeholder$ = i18nModule.exports.i18n.selectT(
        "reviews.ReviewsFormModalWidget",
        "guest_email_input_placeholder"
    );
</script>

<FormManagerProvider formManager={guestInfoFormManager}>
    <FormLayout>
        {#if reviewsSettings?.customerDisplayNamePolicy === REVIEWER_NAME_DISPLAY_FORMAT.CUSTOMER_CHOICE}
            <FormManagerController name="customerDisplayNamePolicy" let:field>
                <FormLayoutItem
                    errors={field.errors || []}
                    namespace="reviews.ReviewsFormModalWidget"
                >
                    <CustomerNameFormSelect
                        namespace="reviews.ReviewsFormModalWidget"
                        {isAuthenticated}
                        value={field.value}
                        on:change={field.onChange}
                    />
                </FormLayoutItem>
            </FormManagerController>
        {/if}

        <FormManagerController name="guestName" let:field>
            <FormLayoutItem
                errors={field.errors || []}
                label={$t_guest_name_input_label$}
                required
                namespace="reviews.ReviewsFormModalWidget"
            >
                <ReviewsTextInput
                    ariaLabel="Customer username input"
                    placeholder={$t_guest_name_input_placeholder$}
                    type="text"
                    name={field.name}
                    value={field.value}
                    on:change={field.onChange}
                />
            </FormLayoutItem>
        </FormManagerController>

        <FormManagerController name="guestEmail" let:field>
            <FormLayoutItem
                errors={field.errors || []}
                label={$t_guest_email_input_label$}
                required
                namespace="reviews.ReviewsFormModalWidget"
            >
                <ReviewsTextInput
                    ariaLabel="Customer email input"
                    placeholder={$t_guest_email_input_placeholder$}
                    type="email"
                    name={field.name}
                    value={field.value}
                    on:change={field.onChange}
                />
            </FormLayoutItem>
        </FormManagerController>
    </FormLayout>
</FormManagerProvider>
